"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _zhjySerach = _interopRequireDefault(require("@/components/search/zhjySerach.vue"));
var _funBtn = _interopRequireDefault(require("@/components/funBtn/funBtn.vue"));
var _zhjyTable = _interopRequireDefault(require("@/components/table/zhjyTable.vue"));
var _zhjyPagination = _interopRequireDefault(require("@/components/zhjyPagination/zhjyPagination.vue"));
var _school = require("@/api/school/school");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      modelData: {
        queryValue: ""
      },
      defaultColumn: [{
        name: "项目名称",
        prop: "matchName",
        isShow: true,
        width: "200"
      }, {
        name: "阶段名称",
        prop: "stageName",
        isShow: true,
        width: "200"
      }, {
        name: "组别名称",
        prop: "groupName",
        isShow: true,
        width: "200"
      }, {
        name: "开始时间",
        prop: "beginTime",
        isShow: true,
        width: "200"
      }, {
        name: "结束时间",
        prop: "endTime",
        isShow: true,
        width: "200"
      }],
      funBtns: [],
      minWidth: 300,
      page: {
        pageNumber: 1,
        pageSize: 10
      },
      totalData: 0,
      listData: [],
      options: [{
        name: "查看作品",
        class: "edit",
        option: "view",
        span: 3
      }, {
        name: "参赛选手分配",
        class: "editor",
        option: "allotPlayer",
        span: 3
      }],
      formatters: {
        belongAdministrator: []
      },
      sort: {
        prop: "",
        order: ""
      },
      expertId: "",
      queryValue: ""
    };
  },
  methods: {
    // 分配选手
    allotPlayer: function allotPlayer(e) {
      this.$router.push({
        path: "/education/allotPlayerList",
        query: {
          groupId: e.groupId,
          stageId: e.stageId
        }
      });
    },
    // 获取学校下项目阶段列表
    getProjectStageList: function getProjectStageList() {
      var _this = this;
      (0, _school.projectStage)({
        matchId: this.$route.query.id,
        name: this.queryValue,
        pageNum: this.page.pageNumber,
        pageSize: this.page.pageSize
      }).then(function (res) {
        var data = res.data;
        console.log(data.list, "res");
        _this.listData = data.list;
        _this.totalData = data.total;
      });
    },
    //
    view: function view(e) {
      this.$router.push({
        path: "/education/viewProjectWorks",
        query: {
          id: e.groupId,
          stageId: e.stageId,
          matchId: e.matchId,
          groupId: e.groupId
        }
      });
    },
    handleCurrentChange: function handleCurrentChange(e) {
      this.page.pageNumber = e;
      this.getProjectStageList();
    },
    handleSizeChange: function handleSizeChange(e) {
      this.page.pageNumber = 1;
      this.page.pageSize = e;
      this.getProjectStageList();
    }
  },
  components: {
    ZhjySerach: _zhjySerach.default,
    ZhjyPagination: _zhjyPagination.default,
    FunBtn: _funBtn.default,
    ZhjyTable: _zhjyTable.default
  },
  created: function created() {
    this.getProjectStageList();
  }
};